import { ReactNode } from 'react';

export const asArray = <T = unknown>(value: unknown): T[] => {
  return Array.isArray(value) ? (value as T[]) : [];
};

export const firstArray = <T = unknown>(...values: unknown[]): T[] => {
  for (const value of values) {
    if (Array.isArray(value)) return value as T[];
  }
  return [];
};

export const normalizeRenderableItems = (items?: ReactNode | ReactNode[] | null): ReactNode[] => {
  const itemList = Array.isArray(items) ? items : items ? [items] : [];
  return itemList.filter(Boolean);
};
